
<div class="delete-dialog">


  <div class="delete-body">

    <div style="font-weight:bold;font-size:18px; margin-bottom: 20px;">
      Please enter the screen name to be deleted.
    </div>

    <form novalidate [formGroup]="formValid">
      <mat-form-field appearance="outline" style="width:100%">
        <mat-label>Screen Name</mat-label>
        <input matInput formControlName="screenName"
               [(ngModel)]="deleteScreenName.screenName" required>
                <mat-error *ngFor="let validation of validation_messages.screenName">
                            <span
                                *ngIf="formValid.get('screenName').hasError(validation.type) && (formValid.get('screenName').dirty || formValid.get('screenName').touched)">
                                {{ validation.message }}
                            </span>
                </mat-error>
      </mat-form-field>
    </form>

  </div>

  <div class="delete-footer">
    <button
      class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.background-color]="backgroundColorButton"
      (click)="delete()">
      Delete
    </button>

    <button
      class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.background-color]="backgroundColorButton"
      (click)="cancel()">
      Cancel
    </button>
  </div>

</div>
